export default __webpack_public_path__ + "static/media/android-native.c101f07a.png";